module.exports = __webpack_public_path__ + "images/eyeOpened-151a904ed189d8b9437819ed94395408.svg";